import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

interface WidgetNotificationHeaderProps {
  lastUpdatedAt: string;
  areAllNotificationsRead: boolean;
  onMarkAllAsRead: () => void;
}

const WidgetNotificationHeader = ({
  lastUpdatedAt,
  areAllNotificationsRead,
  onMarkAllAsRead,
}: WidgetNotificationHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-[64px] max-h-[64px] border-b border-slate-100 px-4 flex justify-between items-center">
      <div className="flex flex-col justify-center">
        <p className="text-slate-900">{t('notifications-widget-title')}</p>

        <p>{lastUpdatedAt}</p>
      </div>

      {areAllNotificationsRead ? null : (
        <Button type="link" onClick={onMarkAllAsRead} className="text-sm text-slate-500">
          {t('notifications-mark-all-read')}
        </Button>
      )}
    </div>
  );
};

export default WidgetNotificationHeader;
